import { useEffect, useState } from 'react';
import { FaCookieBite, FaTimes } from 'react-icons/fa';

const AnalyticsNotice = () => {
  const [showNotice, setShowNotice] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Prüfen ob User bereits Cookie Consent hatte aber Analytics nicht aktiviert ist
    const checkAnalyticsStatus = () => {
      const hasConsent = localStorage.getItem('cc_cookie');
      const analyticsEnabled = window.GA_ENABLED === true;
      const noticeDismissed = localStorage.getItem('analytics_notice_dismissed') === 'true';
      
      // Zeige Hinweis wenn:
      // - Bereits Cookie Consent gegeben wurde
      // - Analytics nicht aktiviert ist
      // - Hinweis noch nicht weggedrückt wurde
      if (hasConsent && !analyticsEnabled && !noticeDismissed) {
        setShowNotice(true);
      }
    };

    // Erst nach einem kurzen Delay prüfen, damit Cookie Consent Zeit hat zu laden
    const timer = setTimeout(checkAnalyticsStatus, 2000);
    return () => clearTimeout(timer);
  }, []);

  const openCookieSettings = () => {
    if (window.CookieConsent) {
      window.CookieConsent.showPreferences();
      setShowNotice(false);
    }
  };

  const dismissNotice = () => {
    localStorage.setItem('analytics_notice_dismissed', 'true');
    setShowNotice(false);
    setDismissed(true);
  };

  if (!showNotice || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 max-w-sm bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-xl shadow-2xl z-50 animate-fade-in">
      <div className="flex items-start gap-3">
        <FaCookieBite className="w-6 h-6 mt-1 text-yellow-300" />
        <div className="flex-1">
          <h4 className="font-bold text-sm mb-1">🆕 Analytics hinzugefügt</h4>
          <p className="text-xs mb-3 leading-relaxed">
            Wir haben Google Analytics hinzugefügt, um unsere Website zu verbessern. 
            Möchtest du deine Cookie-Einstellungen anpassen?
          </p>
          <div className="flex gap-2">
            <button
              onClick={openCookieSettings}
              className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg text-xs font-medium transition-colors"
            >
              Einstellungen
            </button>
            <button
              onClick={dismissNotice}
              className="bg-white/10 hover:bg-white/20 px-3 py-1 rounded-lg text-xs transition-colors"
            >
              Später
            </button>
          </div>
        </div>
        <button
          onClick={dismissNotice}
          className="text-white/60 hover:text-white transition-colors"
        >
          <FaTimes className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AnalyticsNotice;
